export function getCardColor({ isLive, isTimer, theme }) {
  return isTimer
    ? theme.colors.brandSecondary
    : isLive
    ? '#000'
    : theme.colors.brandPrimary
}
